import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import SignupBanner from './components/SignupBanner';
import Navbar from './components/Navbar/Navbar';
import AllQuotes from './components/AllQuotes';
import Philosophers from './components/Philosophers';
import Topics from './components/Topics';
import API from './components/API';
import RandomQuote from './components/RandomQuote';
import SingleQuote from './components/SingleQuote';
import QuoteOfTheDay from './components/QuoteOfTheDay';
import Search from './components/Search';
import SearchResults from './components/SearchResults';
import Footer from './components/Footer';
import Unsubscribe from './components/Unsubscribe';

import './App.css';

toast.configure();

const App = () => {
  return (
    <BrowserRouter forceRefresh>
      <div className="min-h-screen flex flex-col justify-between h-full bg-gray-100">
        <div className="flex flex-col">
          {/* <SignupBanner /> */}
          <Navbar />
        </div>
        <div className="flex-grow pt-8 flex flex-col items-center mb-10 md:mx-10 px-4 sm:px-6 lg:px-8 bg-gray-100 pb-10">
          <Routes>
            <Route path="/" element={<QuoteOfTheDay />} />
            <Route path="/philosophers/" element={<Philosophers />} />
            <Route path="/philosophers/:query" element={<Philosophers />} />
            <Route path="/API" element={<API />} />
            <Route path="/topics/" element={<Topics />} />
            <Route path="/topics/:query" element={<Topics />} />
            <Route path="/quote/:quoteid" element={<SingleQuote />} />
            <Route path="/random" element={<RandomQuote />} />
            <Route path="/all" element={<AllQuotes />} />
            <Route path="/search" element={<Search />} />
            <Route path="/search_results" element={<SearchResults />} />
            <Route path="/unsubscribe" element={<Unsubscribe />} />
          </Routes>
        </div>
        <div className="bottom-0 w-full">
          <Footer />
        </div>
      </div>
    </BrowserRouter>
  );
};

export default App;
